import React, { ReactNode } from 'react';
import { makeStyles } from 'tss-react/mui';
import { MAIN_THEME } from '@styles';

interface IWithLinkFormFieldProps {
  children: ReactNode;
  linkText: string;
  addSpace?: boolean;
  onLinkClick: () => void;
}

const useStyles = makeStyles<{ addSpace: boolean }>()(
  (theme, { addSpace }) => ({
    container: {
      position: 'relative',
      marginBottom: addSpace ? '15px' : 0,
    },
    supportLinkContainer: {
      textAlign: 'left',
      position: 'absolute',
      top: '50px',
    },
    link: {
      backgroundColor: 'unset',
      cursor: 'pointer',
      border: 0,
      padding: 0,
      margin: 0,
      textDecoration: 'underline',
      color: 'rgba(211, 13, 43, 0.8)',
      fontSize: MAIN_THEME.fontSize.sm,
      fontFamily: MAIN_THEME.font.regular,
      '&:hover': {
        color: 'rgba(115, 0, 0, 0.8)',
      },
    },
  })
);

const WithLinkFormField: React.FC<IWithLinkFormFieldProps> = ({
  linkText,
  onLinkClick,
  addSpace,
  children,
}) => {
  const { classes } = useStyles({ addSpace });

  return (
    <div className={linkText ? classes.container : ''}>
      {children}
      <div className={classes.supportLinkContainer}>
        <button className={classes.link} onClick={onLinkClick} type="button">
          {linkText}
        </button>
      </div>
    </div>
  );
};

export default WithLinkFormField;
